import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournalTemplateInputGroup  {
    _originalTypeClassName = "zERP.BO.GeneralJournalTemplateInputGroup";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournalTemplateInputGroup.translate = translateService;
}
this.Accounts = [];
this.Amounts = [];
this.Lines = [];
this.Id = null;
this.Name = null;
this.IsRepeating = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
IsRepeating:any;
Accounts:any;
Amounts:any;
Lines:any;
static setAccounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Accounts == null) $this.Accounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Accounts.length > 0) {
                    Domain.GeneralJournalTemplateInputGroup.removeAccounts($this, $this.Accounts[0]);
                }

                Domain.GeneralJournalTemplateInputGroup.addManyAccounts($this, copyItems);
            }
static addManyAccounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalTemplateInputGroup.addAccounts($this, items[i]);
                }
            }
static addAccounts = ($this, item) => {
                if ($this.Accounts == null) $this.Accounts = [];
                if (item == null || $this.Accounts.indexOf(item) > -1) return;
                $this.Accounts.push(item);
}
static addRangeAccounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalTemplateInputGroup.addAccounts($this, item));
            }
static removeAccounts = ($this, item) => {
                if ($this == null || $this.Accounts == null || $this.Accounts.indexOf(item) === -1) return;
                var _index = $this.Accounts.indexOf(item);
                $this.Accounts.splice(_index, 1);
}
static clearAccounts = ($this) => { $this.Accounts = null; }
static setAmounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Amounts == null) $this.Amounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Amounts.length > 0) {
                    Domain.GeneralJournalTemplateInputGroup.removeAmounts($this, $this.Amounts[0]);
                }

                Domain.GeneralJournalTemplateInputGroup.addManyAmounts($this, copyItems);
            }
static addManyAmounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalTemplateInputGroup.addAmounts($this, items[i]);
                }
            }
static addAmounts = ($this, item) => {
                if ($this.Amounts == null) $this.Amounts = [];
                if (item == null || $this.Amounts.indexOf(item) > -1) return;
                $this.Amounts.push(item);
}
static addRangeAmounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalTemplateInputGroup.addAmounts($this, item));
            }
static removeAmounts = ($this, item) => {
                if ($this == null || $this.Amounts == null || $this.Amounts.indexOf(item) === -1) return;
                var _index = $this.Amounts.indexOf(item);
                $this.Amounts.splice(_index, 1);
}
static clearAmounts = ($this) => { $this.Amounts = null; }
static setLines = ($this, items) => {
                if (items == null) items = [];
                if ($this.Lines == null) $this.Lines = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Lines.length > 0) {
                    Domain.GeneralJournalTemplateInputGroup.removeLines($this, $this.Lines[0]);
                }

                Domain.GeneralJournalTemplateInputGroup.addManyLines($this, copyItems);
            }
static addManyLines = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalTemplateInputGroup.addLines($this, items[i]);
                }
            }
static addLines = ($this, item) => {
                if ($this.Lines == null) $this.Lines = [];
                if (item == null || $this.Lines.indexOf(item) > -1) return;
                $this.Lines.push(item);
}
static addRangeLines = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalTemplateInputGroup.addLines($this, item));
            }
static removeLines = ($this, item) => {
                if ($this == null || $this.Lines == null || $this.Lines.indexOf(item) === -1) return;
                var _index = $this.Lines.indexOf(item);
                $this.Lines.splice(_index, 1);
}
static clearLines = ($this) => { $this.Lines = null; }

static AddLine($this: any): any{let line = new Domain.GeneralJournalTemplateGroupLine();
for (let _iamount = 0; _iamount < ($this?.Amounts == null ? 0 : $this?.Amounts.length); _iamount++) {let amount = $this?.Amounts[_iamount];let am = new Domain.GeneralJournalDocumentTemplateAmount();am.Name = amount?.Name;am.Id = amount?.Id;line?.Amounts?.add(am);}
for (let _iaccount = 0; _iaccount < ($this?.Accounts == null ? 0 : $this?.Accounts.length); _iaccount++) {let account = $this?.Accounts[_iaccount];line?.Accounts?.add(account);}
$this?.Lines?.add(line);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}